import { forwardRef } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import BaseBlock from "./BaseBlock";
import SelfInformationList from './SelfInformationList';
import Selfy from './Selfy';

import { FadeInAnimation } from './animation/Animation';


function AboutMeContent(props) {
    return (
        <Grid container
            spacing={4}
            justifyContent="center"
        >
            <Grid item xs={12} sm={12} md={12} align="center">
                <Selfy imgSrc="/static/me.webp"></Selfy>
            </Grid>

            <Grid item xs={12} sm={12} md={8}
                sx={{
                    textAlign: {
                        xs: "center",
                        sm: "center",
                        md: "left"
                    }
                }}
            >
                <Typography
                    gutterBottom
                    color="customText.dark"
                    sx={{
                        fontWeight: "bold",
                        fontSize: "2.5rem",
                    }}
                >
                    Who am I ?
                </Typography>
                <Typography
                    color="customText.main"
                    sx={{
                        typography: {
                            xs: 'body1',
                            sm: 'body1',
                            md: 'bodyWhoAmI'
                        },
                        textAlign: "justify"
                    }}
                    variant="body1"
                >
                    {props.data.selfIntro}
                </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={4}
                sx={{
                    textAlign: {
                        xs: "center",
                        sm: "center",
                        md: "left"
                    }
                }}
            >
                <SelfInformationList data={props.data}></SelfInformationList>
            </Grid>
        </Grid>
    )
}

const AboutMeBlock = forwardRef((props, ref) => {
    return (
        <BaseBlock
            blockTitle="ABOUT ME"
            blockSubtitle="Full Stack Developer / Master's Degree"
            blockContent={<AboutMeContent data={props.data}></AboutMeContent>}
            ref={ref}
        >
        </BaseBlock>
    )
});

const AboutMe = forwardRef((props, ref) => {
    return (
        <Box ref={ref}>
            <FadeInAnimation
                block={<AboutMeBlock data={props.data}></AboutMeBlock>}
            >
            </FadeInAnimation>
        </Box>
    )
})

export default AboutMe;
